import { css } from "@stubhub/broadway-foundation/css";

export const festivalCarouselContainer = css({
  marginBlockStart: "primitives.200",
  marginBlockEnd: "primitives.400",
  desktop: {
    marginBlockEnd: "primitives.0",
  },
});

export const festivalCard = css({
  alignItems: "flex-start",
  backgroundColor: "bg",
  borderEndEndRadius: "container",
  borderEndStartRadius: "container",
  borderStartEndRadius: "container",
  borderStartStartRadius: "container",
  boxShadow: "[inset 0 0 0 1px {colors.border}]",
  display: "flex",
  flexDirection: "column",
  height: "full",
  paddingBlockEnd: "primitives.150",
  paddingBlockStart: "primitives.150",
  paddingInlineEnd: "primitives.150",
  paddingInlineStart: "primitives.150",
  rowGap: "primitives.150",
});

export const festivalCardImage = css({
  borderEndEndRadius: "[10px]",
  borderEndStartRadius: "[10px]",
  borderStartEndRadius: "[10px]",
  borderStartStartRadius: "[10px]",
  height: "[104px]",
  objectFit: "cover",
  width: "full",
});

export const festivalCardDetails = css({
  display: "flex",
  flexDirection: "column",
  flexGrow: "1",
  rowGap: "primitives.25",
  width: "full",
});

export const festivalCardTitle = css({
  lineClamp: 2,
  overflowX: "hidden",
  overflowY: "hidden",
});
